import type { ToggleDarkModeAction } from '../types/actions'

import { actionFactory } from './factory'

export const toggleDarkMode = actionFactory<ToggleDarkModeAction>(
  (state, isDarkMode) => {
    state.darkMode = isDarkMode !== undefined ? isDarkMode : !state.darkMode
  },
  'toggleDarkMode'
)
